<button 
  (click)="onExport()" 
  class="excelBtn"
  [pTooltip]="fileName === 'customers' ? ('LIDS.EXPORT_TO_ALL_LIDS' | translate) : ('BUSINESS_COUPON.EXPORT' | translate)"
  tooltipPosition="bottom">
</button>